// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { number, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isAgentConsoleCreditRatiosResult = objectOf({
  braze_auto_credit_ratio: anyOf(nullOrUndefined, number),
  byo_llm_api_key_credit_ratio: anyOf(nullOrUndefined, number),
});
